module.exports = __webpack_public_path__ + "static/media/podium-star.ab7ca47b.svg";